// Estilos
import '../estilos/footer.css';
import SuscribirKlaviyo from '../componentesEspeciales/cuenta/suscribirKlaviyo';
import { pixelClickDescargaApp, pixelSuscribirKlaviyo } from '../funcionesDatos/pixelFacebook';
import { gtagClickDescargaApp, gtagSuscribirKlaviyo } from '../funcionesDatos/pixelGoogle';
import { ttqClickDescargaApp, ttqSuscribirKlaviyo } from '../funcionesDatos/pixelTiktok';
import { eventoSuscribirKlaviyo, eventoClickDescargaApp } from '../funcionesDatos/eventoPropio';
import { useEffect } from 'react';


function Footer({ usuario, setUsuario }){

    // Escucha el evento nativo de Klaviyo cuando alguien envía el formulario embed del footer
    useEffect(() => {
        function onKlaviyoForm(e) {
            if (e.detail?.type === 'submit') {
                pixelSuscribirKlaviyo({ origen: 'footer' });
                gtagSuscribirKlaviyo({ origen: 'footer' });
                ttqSuscribirKlaviyo({ origen: 'footer' });
                eventoSuscribirKlaviyo({ origen: 'footer', usuarioId: usuario?.idUsuario });
            }
        }
        window.addEventListener('klaviyoForms', onKlaviyoForm);
        return () => window.removeEventListener('klaviyoForms', onKlaviyoForm);
    }, []);


    return( <div className="bg-dark text-light">
    <div className="container">
        <footer className="pt-5">
            {/* SUPERIOR */}
            <div className="row">
                <div className="col-6 col-md-2 mb-3">
                    <h5>Cuidado al consumidor</h5>
                    <ul className="nav flex-column">
                        <li className="nav-item mb-2">
                            <a href="/politica-privacidad" className="nav-link p-0 text-light">Política de privacidad</a>
                        </li>
                        <li className="nav-item mb-2">
                            <a href="/politica-devolucion" className="nav-link p-0 text-light">Política de devolución</a>
                        </li>
                        <li className="nav-item mb-2">
                            <a href="/politica-cookies" className="nav-link p-0 text-light">Política de cookies</a>
                        </li>
                        <li className="nav-item mb-2">
                            <a href="/terminos" className="nav-link p-0 text-light">Términos y condiciones</a>
                        </li>
                        <li className="nav-item mb-2">
                            <a href="/preguntas" className="nav-link p-0 text-light">Preguntas frecuentes</a>
                        </li>
                        <li className="nav-item mb-2">
                            <a href="/soporte" className="nav-link p-0 text-light">Soporte</a>
                        </li>
                    </ul>
                </div>
                <div className="col-6 col-md-2 mb-3">
                    <h5>Cuenta</h5>
                    <ul className="nav flex-column">
                        <li className="nav-item mb-2"> <a href="/usuario/mi-cuenta"      className="nav-link p-0 text-light">Mi cuenta</a> </li>
                        <li className="nav-item mb-2"> <a href="/usuario/reservas"       className="nav-link p-0 text-light">Mis Reservas</a> </li>
                        <li className="nav-item mb-2"> <a href="/usuario/pagos"          className="nav-link p-0 text-light">Mis Pagos</a> </li>
                        <li className="nav-item mb-2"> <a href="/usuario/favoritos"      className="nav-link p-0 text-light">Mis favoritos</a> </li>
                        <li className="nav-item mb-2"> <a href="/usuario/notificaciones" className="nav-link p-0 text-light">Mis notificaciones</a> </li>
                    </ul>
                </div>
                <div className="col-6 col-md-2 mb-3">
                    <h5>Explorar</h5>
                    <ul className="nav flex-column">
                        <li className="nav-item mb-2"> <a href="/" className="nav-link p-0 text-light">Inicio</a> </li>
                        <li className="nav-item mb-2"> <a href="/busqueda" className="nav-link p-0 text-light">Búsqueda</a> </li>
                        <li className="nav-item mb-2"> <a href="/reserva" className="nav-link p-0 text-light">Carrtito</a> </li>
                        <li className="nav-item mb-2"> <a href="/como-funciona" className="nav-link p-0 text-light">Cómo funciona</a> </li>
                        <li className="nav-item mb-2"> <a href="/links" className="nav-link p-0 text-light">Links</a> </li>
                    </ul>
                </div>
                <div className="col-md-5 offset-md-1 mb-3 position-relative">
                    {!(usuario && usuario.aceptaMarketing) && (
                        <div>
                            <h5>Subscríbete a nuestro blog</h5>
                            <p>Nuevos servicios, promociones, eventos y mucho más.</p>
                            <div className="klaviyo-form-RhyUKw"></div>
                        </div>
                    )}

                    <div className="mt-3">
                        <h6 className="mb-3">Descarga Zervicy</h6>
                        <div className="d-flex flex-column flex-sm-row gap-2 mb-4">
                            <a
                                href="https://apps.apple.com/co/app/zervicy/id6761780592"
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-light d-flex align-items-center justify-content-center gap-2 rounded-pill px-3"
                                aria-label="Descargar Zervicy en iOS"
                                onClick={() => { pixelClickDescargaApp({ plataforma: "ios" }); gtagClickDescargaApp({ plataforma: "ios" }); ttqClickDescargaApp({ plataforma: "ios" }); eventoClickDescargaApp({ plataforma: "ios", usuarioId: usuario?.idUsuario }); }}
                            >
                                <i className="bi bi-apple"></i>
                                <span>Descarga iOS</span>
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.zervicy.app"
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-light d-flex align-items-center justify-content-center gap-2 rounded-pill px-3"
                                aria-label="Descargar Zervicy en Android"
                                onClick={() => { pixelClickDescargaApp({ plataforma: "android" }); gtagClickDescargaApp({ plataforma: "android" }); ttqClickDescargaApp({ plataforma: "android" }); eventoClickDescargaApp({ plataforma: "android", usuarioId: usuario?.idUsuario }); }}
                            >
                                <i className="bi bi-google-play"></i>
                                <span>Descarga Android</span>
                            </a>
                        </div>

                        <h6 className="mb-3">Contáctanos y síguenos</h6>
                        <p className="mb-1">
                            <a href="mailto:info@zervicy.com" className="text-light text-decoration-none">
                            Correo: info@zervicy.com
                            </a>
                        </p>
                        <p className="mb-0">
                            <a href="tel:+573124964754" className="text-light text-decoration-none">
                            Teléfono: +57 312 4964754
                            </a>
                        </p>
                    </div>

                    {/* REDES SOCIALES */}
                    <div className="redesInferior text-center">
                        <ul className="list-unstyled d-flex justify-content-center m-0">
                        <li className="ms-3">
                            <a className="link-body-emphasis" href="https://www.instagram.com/zervicy" aria-label="Instagram">
                            <i className="bi bi-instagram iconoRedes"></i>
                            </a>
                        </li>
                        <li className="ms-3">
                            <a className="link-body-emphasis" href="https://www.facebook.com/zervicy/" aria-label="Facebook">
                            <i className="bi bi-facebook iconoRedes"></i>
                            </a>
                        </li>
                        <li className="ms-3">
                            <a className="link-body-emphasis" href="https://www.tiktok.com/@zervicy" aria-label="TikTok">
                            <i className="bi bi-tiktok iconoRedes"></i>
                            </a>
                        </li>
                        <li className="ms-3">
                            <a className="link-body-emphasis" href="https://wa.me/573189859423?text=Hola%2C%20necesito%20ayuda%20con%20Zervicy" target="_blank" rel="noreferrer" aria-label="WhatsApp">
                            <i className="bi bi-whatsapp iconoRedes"></i>
                            </a>
                        </li>
                        <li className="ms-3">
                            <a className="link-body-emphasis" href="tel:+573124964754" aria-label="Llamar">
                            <i className="bi bi-telephone-fill iconoRedes"></i>
                            </a>
                        </li>
                        <li className="ms-3">
                            <a className="link-body-emphasis" href="mailto:info@zervicy.com" aria-label="Correo electrónico">
                            <i className="bi bi-envelope-fill iconoRedes"></i>
                            </a>
                        </li>
                        <li className="ms-3">
                            <a className="link-body-emphasis" href="https://www.youtube.com/@zervicy" target="_blank" rel="noreferrer" aria-label="YouTube">
                            <i className="bi bi-youtube iconoRedes"></i>
                            </a>
                        </li>
                        </ul>
                    </div>
                </div>
            </div>




            {/* INFERIOR */}
            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3 py-4 border-top">
                <div>
                    <p className="mb-0">&copy; 2026 Zervicy. Todos los derechos resevados.</p>
                    <p className="mb-0 text-white-50" style={{ fontSize: 13, fontStyle: "italic" }}>Encuentra el servicio que necesitas, cuando lo necesitas.</p>
                </div>

                {/* MÉTODOS DE PAGO ACEPTADOS: chip blanco detrás — los logos están pensados para
                    verse sobre fondo claro y se pierden directo sobre el footer oscuro. */}
                <div
                  className="rounded-pill d-inline-flex align-items-center"
                  style={{ background: "var(--blanco)", padding: "8px 16px" }}
                >
                  <img
                    src="/imagenes/pagoswompi.png"
                    alt="Pagos seguros con Visa, Mastercard, American Express, DaviPlata, Nequi y PSE"
                    style={{ maxWidth: 200, width: "100%", height: "auto", display: "block" }}
                  />
                </div>

                <p className="mb-0">Hecho por <a style={{textDecoration: "none"}} href="https://pretwor.com/" target="_blank" rel="noreferrer">Pretwor</a> y <a style={{textDecoration: "none"}} href="https://www.eduardoarias.co/" target="_blank" rel="noreferrer">Eduardo Arias</a>.</p>
            </div>
        </footer>
    </div>
    </div>
    )
}

export default Footer;